import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=21f62554&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=21f62554&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f62554",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21f62554')) {
      api.createRecord('21f62554', component.options)
    } else {
      api.reload('21f62554', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=21f62554&scoped=true&", function () {
      api.rerender('21f62554', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2eg3tNOmVeG0q/JS/comp/GuestBox.vue"
export default component.exports